import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

// actions
import { clearBarMessage } from '../../../Actions/messages';
import { resendEmailConformation } from '../../../Actions/users';

// styles
import './TopBarUserMessage.css';
import {isMobile} from "../../../utils";

class TopBarUserMessage extends Component {
    constructor(props) {
        super(props);
    }

    getBarType() {
        if (this.props.msgError) return 'error';
        if (this.props.msgWarning) return 'warning';
        return 'info';
    }

    getBarText() {
        if (this.props.msgError) return this.props.msgError;
        if (this.props.msgWarning) return this.props.msgWarning;
        // horrible hack- good for enough for now..
        if (this.props.msgType === 'resendEmail' && isMobile()) return ''
        return this.props.msgInfo;

    }

    handleResendEmail() {
        this.props.resendEmailConformation();
        this.props.clearBarMessage();
    }

    renderButtons() {
        if (!this.props.msgType || this.props.msgType !== 'resendEmail') return null;

        // 'Confirm email - Tap here to resend' : '- Resent conformation email';
        const btnText = isMobile() ? 'אשרו מייל - הקישו לשליחה חוזרת' : '- שלחו מחדש מייל אימות';
        return (
            <label className="user-message-btn-wrapper">
                <a onClick={() => this.handleResendEmail()}>{btnText}</a>
            </label>
        )
    }

    render() {
        if (!this.props || (!this.props.msgInfo && !this.props.msgWarning && !this.props.msgError)) return null;

        if (this.props.msgType === 'resendEmail' && this.props.isVerified) return null;

        // style={{width: window && window.innerWidth}}
        return (
            <div className="top-bar-user-message-wrapper rtl" >
                <div className={`top-bar ${this.getBarType()}`}>
                    <p className="top-bar-text">
                        {this.getBarText()}
                    </p>
                    {this.renderButtons()}
                    <div className="top-bar-close-btn" onClick={() => this.props.clearBarMessage()}>X</div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => ({
    msgInfo: state.messages.info,
    msgWarning: state.messages.warning,
    msgError: state.messages.error,
    msgType: state.messages.msgType,
    isVerified: state.users.isVerified
});

TopBarUserMessage.propTypes = {
    onClick: PropTypes.func,

    // state props
    msgInfo: PropTypes.string,
    msgWarning: PropTypes.string,
    msgError: PropTypes.string,
    msgType: PropTypes.oneOf(['resendEmail', '']),
    isVerified: PropTypes.bool,

    // state actions
    clearBarMessage: PropTypes.func,
    resendEmailConformation: PropTypes.func
};

export default connect(mapStateToProps, { clearBarMessage, resendEmailConformation })(TopBarUserMessage);



// WEBPACK FOOTER //
// ./src/Components/Modals/TopBarUserMessage/TopBarUserMessage.js